export enum ResidencyBasis {
  Own = "Own",
  Rent = "Rent",
  LivingRentFree = "LivingRentFree",
  Unknown = "Unknown"
}
